import React, { useState, ReactElement, Component, useEffect, useMemo, useContext, Dispatch, SetStateAction, useRef } from "react";
import "./user-info.less";
import { FormattedMessage } from "react-intl";
import TopNavbar, { log_out } from "../top-navbar/top-navbar";
import { datacenter_url } from "../top-navbar/interface";
import { withRouter } from "react-router-dom";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import { UsernameLoginContext } from "../../contexts/username-login";
import { RolesContext, role_type } from "../../contexts/roles";
import { ClustersForPageContext, clusters_for_page_type } from "../../contexts/clusters-for-page";
import { TypeNameContext } from "../../contexts/type_name";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { LastContext } from "../../contexts/last";
import { item, ItemsContext } from "../../contexts/items";
import { http_request } from "../../worker/http-func";
import Cookies from "universal-cookie";
import { get_time } from "../../shared-functions";
import { workspaces_type_item, WorkspaceContext } from "../../contexts/workspaces";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { user_subscription, UserSubscriptionsContext } from "../../contexts/user-subscriptions";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { ClusterContext, clusters_type_item } from "../../contexts/clusters";
import { EnvContext } from "../../contexts/env";
import { permissions } from "../../permissions";
import "../tools/tools.less";
import Tools from "../tools/tools";
import { hammer, close, wise_iot_suite } from "../../img";
import { Popover, Menu, Col, Button } from "antd";
import { ToolsCloseContext } from "../../contexts/tools_close";
import { Version } from "../../app/enum/version.enum";
import { IsFreshContext } from "../../contexts/is_fresh";
import { license_type, LicenseContext } from "../../contexts/license";
import { SubscriptionSelectedContext } from '../../pages/service/contexts/subscription-selected';
import { subscriptionType } from '../../pages/service/common-file/interfaceType';
import { EnableAutoscaleContext, enable_autoscale_type } from "../../contexts/enable-autoscale";
import { ShowGuideContext } from '../../contexts/show-guide';
import { FlyInContext } from "../../contexts/fly-in";
import { ThemeContext } from "../../contexts/theme";
import { SubMenu } from "rc-menu";
import { MenuInfo } from "rc-menu/lib/interface";
import { UnitContext } from "../../contexts/unit";
import { LangContext } from "../../contexts/lang";
import { useDeepCompareEffect } from 'use-deep-compare';
import { SettingParamsContext } from "../../contexts/setting_params";

const UserInfo: (props: any) => React.ReactElement<any, string | (new (props: any) => React.Component<any, any, any>)> | null = (
  props: any
): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [unit, set_unit]: [string, React.Dispatch<React.SetStateAction<string>>] = useContext(UnitContext);
  const [lang, set_lang]: [any, React.Dispatch<React.SetStateAction<any>>] = useContext(LangContext);
  const theme: string = useContext(ThemeContext)[0];
  const [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useContext(UserInfoContext),
    [datacenter_name, set_datacenter_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(DatacenternameContext),
    set_last: React.Dispatch<React.SetStateAction<string>> = useContext(LastContext)[1],
    set_username_login: React.Dispatch<React.SetStateAction<string | undefined>> = useContext(UsernameLoginContext)[1],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    [roles_1, set_roles]: [role_type[], React.Dispatch<React.SetStateAction<role_type[]>>] = useContext(RolesContext),
    [clusters_for_page, set_clusters_for_page]: [clusters_for_page_type | undefined, Dispatch<SetStateAction<clusters_for_page_type | undefined>>] = useContext(
      ClustersForPageContext
    ),
    type_name: string | undefined = useContext(TypeNameContext)[0],
    set_clusters: React.Dispatch<React.SetStateAction<clusters_type_item[]>> = useContext(ClusterContext)[1],
    set_cluster_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(ClusterSelectedContext)[1],
    set_workspace_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(WorkSpaceSelectedContext)[1],
    set_workspaces: React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>> = useContext(WorkspaceContext)[1],
    set_namespaces: React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>> = useContext(NamespaceContext)[1],
    set_namespace_selected: React.Dispatch<React.SetStateAction<item | undefined>> = useContext(NameSpaceSelectedContext)[1],
    set_items: React.Dispatch<React.SetStateAction<item[]>> = useContext(ItemsContext)[1],
    set_fly_in: Dispatch<SetStateAction<1 | undefined>> = useContext(FlyInContext)[1],
    [env, set_env]: [datacenter_url | undefined, React.Dispatch<React.SetStateAction<datacenter_url | undefined>>] = useContext(EnvContext),
    [tools_close, set_tools_close]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(ToolsCloseContext),
    set_show_guide: React.Dispatch<React.SetStateAction<boolean>> = useContext(ShowGuideContext)[1],
    is_fresh: boolean = useContext(IsFreshContext)[0],
    set_license: React.Dispatch<React.SetStateAction<license_type>> = useContext(LicenseContext)[1],
    // [guide_fold, set_guide_fold]: [boolean,React.Dispatch<React.SetStateAction<boolean>>] = useContext(GuideFoldContext),
    set_user_subscriptions: React.Dispatch<React.SetStateAction<user_subscription[] | undefined>> = useContext(UserSubscriptionsContext)[1],
    subscription_selected: subscriptionType = useContext(SubscriptionSelectedContext)[0],
    set_enable_autoscale: Dispatch<SetStateAction<string>> = useContext(EnableAutoscaleContext)[1],
    setting_params: any = useContext(SettingParamsContext)[0],
    [clusters_for_all, set_clusters_for_all]: [clusters_type_item[] | undefined, Dispatch<SetStateAction<clusters_type_item[] | undefined>>] = useState<
      clusters_type_item[] | undefined
    >(),
    [kubectl_frame, set_kubectl_frame]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState(<div></div>),
    path = useMemo(() => props.history.location.pathname, [props]),
    old_version = localStorage.getItem("mp_version"),
    level: React.MutableRefObject<string[]> = useRef([
      "globalAdmin",
      "datacenterAdmin",
      "clusterAdmin",
      "clusterOwner",
      "workspaceOwner",
      "namespaceDeveloper",
    ]),
    roles_filtered = useMemo(() => {
      const roles_filtered_pre: role_type[] | undefined = roles_1.filter((role_each: role_type): boolean => {
        return role_each.subscriptionId === user_info.subscription_id;
      });
      return roles_filtered_pre
        .sort((a, b) => {
          const find_index = (role_compared: role_type): number => level.current.findIndex((level_each: string) => level_each === role_compared.roleName);
          return find_index(a) - find_index(b);
        })
        .filter(
          (role_each: role_type, index: number): boolean =>
            roles_filtered_pre.findIndex(({ cluster }: role_type) => cluster?.length && cluster === role_each.cluster) === index
        );
    }, [roles_1, user_info.subscription_id]);

  useEffect((): void => {
    if (path.includes("resource/")) {
      path !== "/resource/view" && path !== "/resource/service" && props.history.push("/console");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path])

  useEffect((): void => {
    (async (): Promise<void> => {
      if (!path.includes("login") && datacenter_name) {
        const user_info_new: IUserInfoType = ((await http_request(
          "user_info",
          props,
          undefined,
          `/v1/datacenter/${datacenter_name}/users/me?complete=true`,
          0,
          "globalAdmin",
          undefined,
          datacenter_name,
          cluster_selected?.name || ""
        )) || {}) as IUserInfoType;
        // !user_info_new.role && user_info_new.role !== '' && log_out(env, undefined, props.history);
        // sessionStorage.setItem('show_notice', 'true');
        sessionStorage.setItem('theme', 'blue');
        if (path === "/") {
          props.history.push("/console");
        }
        // if (role !== 'globalAdmin') {
        //     const cluster_session = sessionStorage.getItem('cluster'),
        //         workspace_session = sessionStorage.getItem('workspace'),
        //         cluster_selected_name: string = (roles?.find(role_each => role_each.cluster === cluster_session) || (roles || [])[0])?.cluster,
        //         workspace_selected_name: string | undefined = (roles?.find(role_each => role_each.workspace === workspace_session) || (roles || [])[0])?.workspace;
        //     // clusters?.length && set_clusters(clusters);
        //     set_clusters_for_all(clusters);
        //     cluster_selected_name && set_cluster_selected({ name: cluster_selected_name, key: 'cluster' });
        //     set_roles(roles);
        //     workspace_selected_name && set_workspace_selected({ name: workspace_selected_name, key: 'workspace' });
        //     set_clusters_for_page({ clusters_for_clusters_page, clusters_for_workspaces_page });
        // } else {
        //     set_user_info(currentState => ({  ...currentState, role:role }));
        // }

        if (user_info_new.code === 401) {
          log_out({props, env: undefined, history: props.history, redirect_url: "/login/sign-in"});
          // set_user_info((currentState) => ({ ...currentState, role: "" }));   
        } else {
          const subscription_session = new Cookies().get("subscription_id"),
            userSubscriptions_new = user_info_new.userSubscriptions?.sort((a: user_subscription, b: user_subscription) =>
              a.subscriptionName.toLocaleLowerCase().localeCompare(b.subscriptionName.toLocaleLowerCase())
            ),
            subscription_id: string | undefined = (
              userSubscriptions_new?.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === subscription_session) ||
              (userSubscriptions_new || [])[0]
            )?.subscriptionId,
            userSubscriptions_new_mpDefault =
              userSubscriptions_new &&
              userSubscriptions_new
                .filter((userSubscription: any) => userSubscription.subscriptionName !== "MPDefaultGroup")
                .concat(userSubscriptions_new.filter((userSubscription: any) => userSubscription.subscriptionName === "MPDefaultGroup"));
          userSubscriptions_new_mpDefault && set_user_subscriptions(userSubscriptions_new_mpDefault);
          const np_cluster_new = user_info_new.roles?.filter((each: any, index: number) => each.roleName === "namespaceDeveloper"
          );
          const wk_cluster_new = user_info_new.roles?.filter((each: any, index: number) => each.roleName === "workspaceOwner"
          );
          const wk_np_cluster_new: string[] = [];
          np_cluster_new && np_cluster_new.map((each: any) => {
            wk_cluster_new && wk_cluster_new.filter((each_item: any) => {
              if (each_item.subscriptionId === each.subscriptionId && each_item.cluster === each.cluster && each_item.clusterType === each.clusterType) {
                wk_np_cluster_new.push(each.cluster)
              }
              return wk_np_cluster_new
            })
            return wk_np_cluster_new
          });
          // console.log(np_cluster_new, wk_cluster_new, wk_np_cluster_new );

          set_user_info((currentState) => ({
            ...currentState,
            ...user_info_new,
            subscription_id,
            is_globaladmin: Number(user_info_new.role === "globalAdmin"),
            is_datacenteradmin: Number(user_info_new.role === "datacenterAdmin"),
            is_clusteradmin: Number(user_info_new.role === "clusterAdmin"),
            is_clusterowner: Number(user_info_new.role === "clusterOwner"),
            is_workspaceowner: Number(user_info_new.role === "workspaceOwner"),
            is_namespacedeveloper: Number(user_info_new.role === "namespaceDeveloper"),
            wkOwner_has_namespacedeveloper: wk_np_cluster_new
            // has_namespacedeveloper: Number(user_info_new.roles?.filter((each: any) => each.roleName === 'namespaceDeveloper')?.length)
          }));
          user_info_new.roles && set_roles(user_info_new.roles);
          set_last(user_info_new.lastSignedInTime ? get_time(user_info_new.lastSignedInTime * 1000) : "");
          set_username_login(user_info_new.userName || "");
          // if (user_info_new.code === 401) log_out(env);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_user_info, datacenter_name, path, is_fresh]);

  useEffect((): void => {
    const sort_and_map: Function = (roles_filtered: role_type[]): clusters_type_item[] =>
      roles_filtered
        .sort((a: role_type, b: role_type): number => a.cluster?.toLocaleLowerCase().localeCompare(b.cluster?.toLocaleLowerCase() || ""))
        .map(
          ({ cluster, clusterType, roleName, subscriptionId }: role_type): clusters_type_item => {
            return ({
              metadata: { name: cluster, key: "cluster", labels: { type: clusterType as string, role: roleName as string } },
              subscriptionId: subscriptionId,
              // status: { status: "Active" },
            } as unknown) as clusters_type_item;
          }
        ),
      clusters = sort_and_map(roles_filtered, "cluster"),
      // sort_and_map(roles_filtered, 'workspace');
      filter_clusters = (level_required: number, type?: number): clusters_type_item[] | undefined => {
        const filtered_clusters: clusters_type_item[] = sort_and_map(
          roles_1
            ?.filter((role_each: role_type): boolean => {
              return path.includes("monitor/service-usage") ? role_each.subscriptionId === subscription_selected?.subscriptionId : role_each.subscriptionId === user_info.subscription_id;
            })
            .filter(({ roleName }: role_type): boolean => level.current.findIndex((level_each: string) => level_each === roleName) < level_required)
        );
        let clusters_new: clusters_type_item[] = filtered_clusters.filter(
          (cluster_each: clusters_type_item, index: number): boolean =>
            filtered_clusters?.findIndex(({ metadata }: clusters_type_item) => filtered_clusters?.length && metadata.name === cluster_each.metadata.name) ===
            index
        );
        type !== undefined && (clusters_new = clusters_new.filter((item: clusters_type_item) => item.metadata.labels.type === (type ? "shared" : "dedicate")));
        return clusters_new.length ? clusters_new : undefined;
      };
    clusters && set_clusters_for_all(clusters);
    set_clusters_for_page({
      clusters_for_dedicate_clusters_page: filter_clusters(4, 0),
      clusters_for_shared_clusters_page: filter_clusters(4, 1),
      clusters_for_dedicate_workspaces_page: filter_clusters(5, 0),
      clusters_for_shared_workspaces_page: filter_clusters(5, 1),
      clusters_for_dedicate_namespaces_page: filter_clusters(6, 0),
      clusters_for_shared_namespaces_page: filter_clusters(6, 1),
      clusters_for_nodes_page: filter_clusters(4),
      clusters_for_monitor_page: filter_clusters(6),
      clusters_for_workspace_quotas_page: filter_clusters(5),
      clusters_for_serviceUsage_page: filter_clusters(6),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles_1, set_clusters_for_all, set_clusters_for_page, user_info.subscription_id, roles_filtered, subscription_selected?.subscriptionId, path]);

  useEffect((): void => {
    if (clusters_for_page) {
      const clusters_for_page_selected: clusters_type_item[] | undefined = (clusters_for_page as { [key: string]: clusters_type_item[] | undefined })[
        `clusters_for_${path.includes("console")
          ? `monitor`
          : path.includes("clusters") || path.includes("cluster-info/overview")
            ? `${type_name}_clusters`
            : path.includes("workspaces") || path.includes("workspace-info/overview")
              ? `${type_name}_workspaces`
              : path.includes("namespaces") || path.includes("namespace-info/overview") || path.includes("namespace-info/workloads")
                ? `${type_name}_namespaces`
                : path.includes("nodes")
                  ? "nodes"
                  : (path.includes("monitor") && path.includes("service-usage")) ||
                    path.includes("quotas/namespace-quotas") ||
                    path.includes("user") ||
                    path.includes("ingress-info/ingress") ||
                    path.includes("applications") ||
                    path.includes("terminal") ||
                    path.includes("application/workload") ||
                    path.includes("records")
                    ? "monitor"
                    : path.includes("quotas/workspace-quotas")
                      ? "workspace_quotas"
                      : path.includes("monitor/service-usage") && "serviceUsage"
        }_page`
      ];

      clusters_for_page_selected
        ? set_clusters(clusters_for_page_selected)
        : clusters_for_all && level.current.indexOf(user_info.role) > 1
          ? set_clusters(clusters_for_all)
          : set_clusters([]);
    }
  }, [path, clusters_for_page, set_clusters, clusters_for_all, user_info.role, datacenter_name, type_name]);

  useEffect(() => {
    const cluster_selected_new =
      cluster_selected || roles_filtered.map(({ cluster, clusterType, roleName }: role_type) => ({ name: cluster, clusterType, roleName }))[0],
      workspace_selected_new = roles_filtered
        .filter(({ cluster }: role_type): boolean => cluster === cluster_selected_new?.name)
        .map(({ workspace }: role_type) => ({ name: workspace }))[0],
      namespace_selected_new = roles_filtered
        .filter(({ workspace }: role_type): boolean => workspace === workspace_selected_new?.name)
        .map(({ namespace }: role_type) => ({ name: namespace }))[0],
      { roleName } =
        roles_filtered.find(({ cluster, workspace, namespace, roleName }: role_type): boolean => {
          switch (roleName) {
            case "clusterAdmin":
            case "clusterOwner":
              return cluster === cluster_selected_new?.name;
            case "workspaceOwner":
              return cluster === cluster_selected_new?.name && workspace === workspace_selected_new?.name;
            case "namespaceDeveloper":
              return cluster === cluster_selected_new?.name && workspace === workspace_selected_new?.name && namespace === namespace_selected_new?.name;
            default:
              return false;
          }
        }) || {};

    set_user_info((currentState) => ({ ...currentState, role: roleName || roles_filtered[0]?.roleName }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_user_info, cluster_selected?.name, workspace_selected?.name, roles_filtered]);

  useEffect((): void => {
    set_workspaces(undefined);
    set_namespaces(undefined);
    set_items([]);
  }, [
    user_info.subscription_id,
    type_name,
    set_cluster_selected,
    set_clusters,
    set_items,
    set_namespace_selected,
    set_namespaces,
    set_workspace_selected,
    set_workspaces,
  ]);

  useEffect((): void => {
    if (
      (path.includes("clusters") || path.includes("workspaces") || path.includes("namespaces") || path.includes("workloads") || path.includes("-info")) &&
      !path.includes("ingress") && !path.includes("resource") && !path.includes("restart-alarm") &&
      cluster_selected?.labels?.role
    ) {
      const key = (path.match(/\/(.*)-info\//) || [])[1]
        ? path.includes("overview")
          ? `${(path.match(/\/(.*)-info\//) || [])[1]}s`
          : path.substring(path?.lastIndexOf("/") + 1)
        : path.substring(1),
        permission: number = (((cluster_selected?.labels?.role !== "" && permissions[key][cluster_selected?.labels?.role]) ||
          new Int32Array()) as Int32Array)[3];
      if ((path === "/clusters" || path === "/cluster-info/overview") && permission === 0) {
        user_info.role === "workspaceOwner"
          ? props.history.push("/cluster-info/workspaces")
          : user_info.role === "namespaceDeveloper" && props.history.push("/workspace-info/namespaces");
      } else if ((path === "/cluster-info/workspaces" || path === "/workspace-info/overview") && permission === 0) {
        user_info.role === "namespaceDeveloper" && props.history.push("/workspace-info/namespaces");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info.role, path, props.history, cluster_selected?.labels?.role]);

  useEffect(() => {
    const new_version = (Version.version_ui).indexOf('-') > -1 ? (Version.version_ui).slice(0, (Version.version_ui).indexOf('-')) : Version.version_ui;
    if (old_version !== new_version && user_info.role && user_info.role !== '') {
      localStorage.setItem("mp_version", new_version);
      sessionStorage.setItem('show_notice', 'true');
      set_show_guide(false);//取消引导框
      set_fly_in(undefined);//取消left-menu默认展开
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info.role]);

  useEffect(() => {
    (async () => {
      if (path.includes("login/sign-in")) {
        const license_invalid = ((await (await fetch("/v1/license/info")).json()) as unknown) as license_type;
        set_license(license_invalid);
      }
    })()
  }, [path, set_license]);

  useEffect((): void => {
    if (tools_close) {
      const { domain }: Document = document;
      const mp_api_session = sessionStorage.getItem("mp_api") || `https://api-mp-ensaas${domain.substr(domain.indexOf('.'))}/v1`;
      if (cluster_selected?.name) {
        const kubectl_frame_new: JSX.Element = <iframe
          title="terminal"
          style={{ width: '0', height: '0', position: 'absolute' }}
          src={(env && env["api-mp"]?.externalUrl ? `${env["api-mp"].externalUrl.substr(0, env["api-mp"].externalUrl.length - 2)}?clusterName=${cluster_selected.name}` : `${mp_api_session.substr(0, mp_api_session.length - 2)}?clusterName=${cluster_selected.name}`)

          }
        />;
        set_kubectl_frame(kubectl_frame_new);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, env, path, tools_close]);

  useEffect(() => {
    !path.includes("records") && sessionStorage.removeItem("record_cluster_all");
  }, [path])

  useEffect(() => {
    (async () => {
      if (path.includes("cluster-info/workspaces") && datacenter_name) {
        const enable_autoscale_new = ((await (await fetch(`/v1/datacenter/${datacenter_name}/config/workspaceautoscale`)).json()) as unknown) as enable_autoscale_type;
        enable_autoscale_new && enable_autoscale_new.value && set_enable_autoscale(enable_autoscale_new.value);
      }
    })()
  }, [path, set_enable_autoscale, datacenter_name]);

  useDeepCompareEffect((): void => {
    if (env && env["api-mp"]?.externalUrl && !sessionStorage.getItem("mp_api")) {
      const apiMpInit = env["api-mp"]?.externalUrl;
      const apiMpProtocol = apiMpInit.slice(0, apiMpInit.indexOf('://') + 1);
      sessionStorage.setItem("mp_api", apiMpProtocol === window.location.protocol ? apiMpInit : apiMpInit.replace(apiMpProtocol, window.location.protocol));
    }
  },[env])

  return (
    // <UserSubscriptionsContext.Provider value={[user_subscriptions, set_user_subscriptions]}>
    //   <TopNavbar />
    //   {
    //     user_info.role && user_info.role !== '' ? path.includes('user/management') || path.includes('user/edit-profile') || path.includes('workspace-info/overview') || path.includes("applications") ||
    //     path.includes("applications-detail") || path.includes("clusters") || path.includes("records") || path.includes("instance-list") || path.includes("create-secret") || path.includes("service-usage") || path.includes("resource/view") || path.includes("resource/service") ? '' :
    //       <Popover content={<Tools />} trigger="click" placement="topLeft" visible={tools_close} onVisibleChange={(visible) => set_tools_close(visible)}>
    //         {
    //           tools_close ?
    //             <div className="tools" style={{ touchAction: 'none', transform: 'translate(0px, 0px)' }} onClick={(e: any)=>{e.stopPropagation();set_tools_close(false);}}>
    //               <span className="tools_icon" style={{ width: '24px', height: '24px' }}>
    //                 <img src={close} alt="close" className="hammer_img" />
    //               </span>
    //             </div> :
    //             <div className="tools" style={{ touchAction: 'none', transform: 'translate(0px, 0px)' }}>
    //               <span className="tools_icon" style={{ width: '20px', height: '20px' }}>
    //                 <img src={hammer} alt="tools" className="hammer_img" />
    //               </span>
    //             </div>
    //         }
    //       </Popover> : ''
    //   }
    // </UserSubscriptionsContext.Provider>
    <div>
      <TopNavbar
        is_mp={1}
        lang={lang}
        portal_name="Management Portal"
        user_name={user_info.userName}
        theme={theme}
        datacenter_name={datacenter_name}
        set_datacenter_name={set_datacenter_name}
        set_env={set_env}
        // fly_in={fly_in}
        portal_logo={{logo: setting_params?.loginPageTopLogo ? setting_params?.loginPageTopLogo : wise_iot_suite, style: { height: '48px' }}}
        set_fly_in={set_fly_in}
        custom_menu_item_click={({ key }: MenuInfo) => {
          if (typeof key === "string" && key !== "log_out" && key !== "sso_link" && key !== "what_new") {
            set_unit(key);
            sessionStorage.setItem("unit", key);
          }
        }}
        custom_buttons={
          !path.includes("login") ? (
            [
              <Col className="nav_button d-flex justify-center">
                <Button className={`home-button ant-col-sm-24 p-0 text-center header_btn_color_${theme}`} onClick={() => props.history.push("/console")}>
                  <div className="nav-icon home-icon" style={{verticalAlign: 'baseline'}}></div>
                </Button>
              </Col>
            ]
          ) : ([])
        }
        custom_menu_items={
          [<SubMenu
            title={
              <span>
                <FormattedMessage id="units" />
              </span>
            }
            className="theme_area"
          >
            <Menu.Item key="Mi" className={unit === "Mi" ? 'unit_item_seledted' : ''}>Megabyte</Menu.Item>
            <Menu.Item key="Gi" className={unit === "Gi" ? 'unit_item_seledted' : ''}>Gigabyte</Menu.Item>
            <Menu.Item key="Ti" className={unit === "Ti" ? 'unit_item_seledted' : ''}>Terabyte</Menu.Item>
            <Menu.Item key="Pi" className={unit === "Pi" ? 'unit_item_seledted' : ''}>Petabyte</Menu.Item>
          </SubMenu>]
        }
        redirect_url="/login/sign-in"
        set_lang={set_lang}
        api_proxy_path={{ecm: "ecm", listing: "listingSystem"}}
      />
      {
        user_info.role && user_info.role !== '' && !path.includes('login') ? (path.includes('user/management') || path.includes('user/edit-profile') || path.includes('user/addusers-profile') || path.includes('user/deleteusers-profile') || path.includes('workspace-info/overview') || path.includes("applications") ||
          path.includes("applications-detail") || path.includes("clusters") || path.includes("records") || path.includes("instance-list") || path.includes("create-secret") || path.includes("service-usage") || path.includes("resource/view") || path.includes("resource/service") ? '' :
          <Popover content={<Tools />} trigger="click" placement="topLeft" visible={tools_close} onVisibleChange={(visible) => set_tools_close(visible)}>
            {
              tools_close ?
                <div className="tools" style={{ touchAction: 'none', transform: 'translate(0px, 0px)' }} onClick={(e: any) => { e.stopPropagation(); set_tools_close(false); }}>
                  <span className="tools_icon" style={{ width: '24px', height: '24px' }}>
                    <img src={close} alt="close" className="hammer_img" />
                  </span>
                </div> :
                <div className="tools" style={{ touchAction: 'none', transform: 'translate(0px, 0px)' }}>
                  <span className="tools_icon" style={{ width: '20px', height: '20px' }}>
                    <img src={hammer} alt="tools" className="hammer_img" />
                  </span>
                </div>
            }
          </Popover>) : ''
      }
      {kubectl_frame}
    </div>
  );
};

export default withRouter(UserInfo);
  // export { UserSubscriptionsContext };
